<template>
    <router-view />
</template>

<script>
export default {
    name: 'Digital-Initiatives-Layout'
}
</script>